export default {
  'Group.addProduct': 'Добавить продукт',
  'Group.report': 'Отчет',
  'Group.sentimentDynamics': 'Динамика тональности',
  'Group.filterTopics': 'Все топики',
}
